<template>
  <el-dialog
    title="司机信息"
    :visible.sync="driver.showDriverEditDialog"
    width="840px"
  >
    <el-single-import ref="singImport" :type="'edit'" />
    <section slot="footer">
      <el-button @click="cancel()">取消</el-button>
      <el-button type="primary" @click="save()">保存</el-button>
    </section>
  </el-dialog>
</template>
<script>
import singleImport from '../../components/driver-manage/single-import.vue'
import { mapState } from 'vuex'
export default {
  components: {
    'el-single-import': singleImport,
  },
  computed: {
    ...mapState({
      driver: (state) => state.driver,
    }),
  },
  methods: {
    cancel() {
      this.$store.commit('driver/update', {
        showDriverEditDialog: false,
      })
    },
    save() {
      this.$refs.singImport.submitForm()
    },
  },
}
</script>
<style></style>
